import type { ReactElement } from "react";
import { CmtsComplaintCreateContainer } from "../../core/containers/domain/complaintsRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsComplaintCreateContainer runtime={props.runtime} />;
}

export default Component;
